import { registerErrorsSideEffect } from './errors'
import { eventsErrorSideEffect } from './events/Error'

export function sideEffect() {
  eventsErrorSideEffect()
  registerErrorsSideEffect()
}
